import {defineQuery, useQuery} from "@pinia/colada";
import {useRoute} from "vue-router";
import {AxiosHttpClient, ConfigRepository, DateAdapter} from "@/modern/core";

const dateAdapter = DateAdapter.instance()

const CACHE_STALE_TIME = import.meta.env.DEV ? -1 : 1000 * 60 * 60

export const useServicesTypesQuery = defineQuery(() => {
    const to = useRoute()
    const configRepositoryAtendimento = ConfigRepository.instance(AxiosHttpClient.getAtendimentoInstance())
    return useQuery({
        staleTime: CACHE_STALE_TIME,
        key: () => ['registerTypes', to.params.id as string],
        async query() {
            const res = await configRepositoryAtendimento.getServiceTypesQuery()
            if(res.isRight()) {
                return res.get()
            }
        },
    })
})

export const useContentListQuery = (atividadeId:string | number) => {
    const configRepository = ConfigRepository.instance(AxiosHttpClient.getInstance())
    return useQuery({
        key: ['contentList', atividadeId],
        staleTime: CACHE_STALE_TIME,
        async query() {
            if (!atividadeId) return [];
            const res = await configRepository.getContentListQuery(atividadeId);
            if (res.isRight()) {
                return res.get();
            }
            return [];
        },
    });
};

export const useMotivosFaltasQuery = () => {
    const to = useRoute()
    const configRepository = ConfigRepository.instance(AxiosHttpClient.getInstance())
    return useQuery({
        key: () => ['tiposFaltas', to.params.id as string],
        staleTime: CACHE_STALE_TIME,
        async query() {
            const res = await configRepository.getMotivosFaltasQuery();
            if (res.isRight()) {
                return res.get();
            }
            return [];
        },
    });
}

export const useEncontrosFiltrosQuery = (params: {
    startDate: () => string | undefined | null,
    endDate: () => string | undefined | null,
    projetoId?: () => string | number | undefined | null,
    grupoId?: () => string | number | undefined | null,
    atividadeId?: () => string | number | undefined | null
}) => {
    const configRepository = ConfigRepository.instance(
        AxiosHttpClient.getInstance()
    )

    const normalize = (v: any) =>
        v === undefined || v === '' ? null : v

    const getStart = () => params.startDate?.()
    const getEnd = () => params.endDate?.()
    const getProjeto = () => params.projetoId?.() ?? null
    const getGrupo = () => params.grupoId?.() ?? null
    const getAtividade = () => params.atividadeId?.() ?? null

    return useQuery({
        enabled: () => {
            return !!getStart() && !!getEnd()
        },

        key: () => [
            'encontro-filtros',
            normalize(getStart()),
            normalize(getEnd()),
            normalize(getProjeto()),
            normalize(getGrupo()),
            normalize(getAtividade())
        ],

        staleTime: CACHE_STALE_TIME,


        async query() {
            const start = getStart()
            const end = getEnd()

            if (!start || !end) return null

            const res = await configRepository.getEncontrosFiltrosQuery(
                start,
                end,
                getProjeto() ?? undefined,
                getGrupo() ?? undefined,
                getAtividade() ?? undefined
            )

            return res.isRight() ? res.get() : null
        }
    })
}